/*
 * PRISM pub/sub — a tiny synchronous event bus shared across PRISM modules.
 *
 * Lets independent feature modules coordinate (cart mutations, variant
 * selection) without importing each other. Exposed as globals so classic
 * <script> assets can use a bare `subscribe(...)` / `PUB_SUB_EVENTS` call.
 *
 * subscribe(eventName, callback) -> returns an unsubscribe() function.
 * publish(eventName, payload)     -> invokes every subscriber synchronously.
 *
 * Event payload contracts (kept stable so feature modules can rely on them):
 *   cartUpdate    { source, cartData }            cartData is the /cart.js JSON
 *   variantChange { data: { sectionId, variant } } variant is a product.variant JSON or null
 *   quantityUpdate{ source, cartData }
 *   cartError     { source, message, errors }
 */
(function () {
  'use strict';

  if (window.PRISM_PUBSUB_READY) return;
  window.PRISM_PUBSUB_READY = true;

  var PUB_SUB_EVENTS = {
    cartUpdate: 'cart-update',
    variantChange: 'variant-change',
    quantityUpdate: 'quantity-update',
    cartError: 'cart-error',
  };

  var registry = {};

  function subscribe(eventName, callback) {
    if (typeof callback !== 'function') return function () {};
    if (!registry[eventName]) registry[eventName] = [];
    registry[eventName].push(callback);

    return function unsubscribe() {
      var list = registry[eventName];
      if (!list) return;
      registry[eventName] = list.filter(function (cb) {
        return cb !== callback;
      });
    };
  }

  function publish(eventName, payload) {
    var list = registry[eventName];
    if (!list) return;
    // Iterate a copy so a subscriber that unsubscribes mid-dispatch is safe.
    list.slice().forEach(function (cb) {
      try {
        cb(payload);
      } catch (err) {
        if (window.console) console.error('PRISM pubsub subscriber error for "' + eventName + '"', err);
      }
    });
  }

  window.PUB_SUB_EVENTS = PUB_SUB_EVENTS;
  window.subscribe = subscribe;
  window.publish = publish;
})();
